import * as React from 'react';
import { ModalRename } from '../../../components/FolderHeader/menu/ModalRename';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedFolder } from '../../../selectors/folders';
import { updateFolder } from '../../../thunk/favorites/updateFolder';
import { closeModalRename } from '../../../actions/folders/actions';

export function ModalRenameContainer() {
  const dispatch = useDispatch();
  const selectedFolder = useSelector(selectSelectedFolder);

  const handleConfirm = (name: string) => {
    dispatch(closeModalRename());

    if (!selectedFolder) {
      return;
    }

    dispatch(
      updateFolder({
        id: selectedFolder.id,
        name,
      }),
    );
  };

  return (
    <ModalRename
      isVisible={true}
      name={selectedFolder ? selectedFolder.name : ''}
      onConfirm={handleConfirm}
      onCancel={() => dispatch(closeModalRename())}
    />
  );
}
